import { Settings } from "lucide-react"

export function SettingsPage() {
  return (
    <div className="p-6">
      <div className="flex items-center gap-3 mb-6">
        <Settings className="size-6 text-muted-foreground" />
        <h1 className="text-2xl font-bold">Settings</h1>
      </div>
      <div className="rounded-lg border bg-card p-12 text-center">
        <p className="text-muted-foreground">
          Admin settings coming in a future phase.
        </p>
      </div>
    </div>
  )
}
